/* Hero name tags -> clickable. Each tag opens the Listen page sorted to that host.
   Boxes are % of the hero photo (hero-sundance-labeled-v2.jpg, 1600x1066). */
(function () {
  var TAGS = [
    { host: 'family',    label: 'Mom',       l: 35.8, t: 19.0, w: 11.0, h: 6.4 },
    { host: 'penelope',  label: 'Penelope',  l: 20.5, t: 31.2, w: 11.6, h: 6.4 },
    { host: 'alejandra', label: 'Alejandra', l: 43.1, t: 31.2, w: 12.5, h: 6.4 },
    { host: 'santiago',  label: 'Santiago',  l: 57.1, t: 34.7, w: 11.0, h: 6.2 },
    { host: 'ethan',     label: 'Ethan',     l: 68.6, t: 31.2, w: 8.4,  h: 6.4 }
  ];

  var css =
    '.hero-tag-link{position:absolute;z-index:3;display:block;border-radius:999px;cursor:pointer;' +
    'transition:transform .15s ease, box-shadow .15s ease;}' +
    '.hero-tag-link:hover,.hero-tag-link:focus-visible{transform:scale(1.06);' +
    'box-shadow:0 0 0 3px #B9843D,0 6px 18px rgba(0,0,0,.35);outline:none;}' +
    '.hero-tag-link span{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);}';

  /* Meet the crew: "Listen to [name]'s podcast" links -> that kid's episodes */
  function crew() {
    var map = { alejandra: 'alejandra', ethan: 'ethan', penelope: 'penelope', santi: 'santiago', santiago: 'santiago' };
    document.querySelectorAll('a').forEach(function (a) {
      var m = /Listen to (\w+)'s podcast/i.exec(a.textContent);
      if (m && map[m[1].toLowerCase()]) a.href = '/pages/listen?host=' + map[m[1].toLowerCase()] + '#episodes';
    });
  }

  /* Shop section: product names become links to the product page */
  function shopTitles() {
    document.querySelectorAll("[id*='__shop'] .multicolumn-card").forEach(function (card) {
      var h = card.querySelector('h3, .inline-richtext');
      var link = card.querySelector('a.link, a[href*="/products/"]');
      if (!h || !link || h.querySelector('a')) return;
      var a = document.createElement('a');
      a.href = link.getAttribute('href');
      a.className = 'peas-title-link';
      a.textContent = h.textContent.trim();
      h.textContent = '';
      h.appendChild(a);
    });
    var st = document.createElement('style');
    st.textContent = '.peas-title-link{color:inherit;text-decoration:none}' +
      '.peas-title-link:hover{text-decoration:underline;text-underline-offset:.2em}';
    document.head.appendChild(st);
  }

  function run() {
    crew();
    shopTitles();
    var media = document.querySelector("[id^='Banner-'][id$='__hero'] .banner__media");
    if (!media || media.querySelector('.hero-tag-link')) return;
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    TAGS.forEach(function (g) {
      var a = document.createElement('a');
      a.className = 'hero-tag-link';
      a.href = '/pages/listen?host=' + g.host + '#episodes';
      a.title = g.host === 'family' ? "Listen to Mom's episode" : 'Listen to ' + g.label + "'s episodes";
      a.style.left = g.l + '%';
      a.style.top = g.t + '%';
      a.style.width = g.w + '%';
      a.style.height = g.h + '%';
      a.innerHTML = '<span>' + a.title + '</span>';
      media.appendChild(a);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
